var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

import { Widget, WidgetHeader, WidgetBody, WidgetFooter, WidgetTitle, WidgetSpinner } from "../";
import { Chart, ChartTooltip, FormatMetric } from "../";

import { getChartColors, getGaChartByType, getGaDataByMetric } from "../../resources/functions/";

import Color from 'color';
import _ from "lodash";

import "./AnalyticsReportOwnersVsTotal.scss";

var AnalyticsReportRegVsPub = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsReportRegVsPub, _Component);

    function AnalyticsReportRegVsPub() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsReportRegVsPub);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            style: {},
            loading: true,
            summary: undefined,
            legend: undefined,
            chart: undefined
        }, _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.report !== _this.props.report) {
                _this.getReport();
            }
        }, _this.getReport = function () {
            var _this$props = _this.props,
                report = _this$props.report,
                compareReport = _this$props.compareReport,
                metric = _this$props.metric;

            // set state

            _this.setState({
                loading: true,
                summary: undefined,
                legend: undefined,
                chart: undefined
            });

            if (!report) {
                return false;
            }

            // load data

            var chart = getGaChartByType("pie", report, metric, "dm:owner");

            if (!chart) {
                return false;
            }

            var compareChart = void 0;

            if (compareReport) {
                compareChart = getGaDataByMetric(compareReport, metric);
            }

            // get data

            var data = chart.data;

            // get colors

            var colors = getChartColors(_extends({}, _this.props, { data: data }));

            // set legends

            var legend = [];

            data.map(function (item, index) {

                legend.push(_extends({}, item, {
                    color: colors[index]
                }));
            });

            // total + other

            var chartTotal = chart.total;

            var compare = void 0,
                compareTotal = void 0,
                comparePercent = void 0;

            if (compareChart && compareChart.total) {
                compareTotal = compareChart.total;
                comparePercent = chartTotal / compareTotal * 100;

                var other = compareTotal - chartTotal;

                if (other > 0) {

                    data.push({
                        id: "other",
                        label: "Andre",
                        value: other
                    });

                    colors.push("rgba(0,0,0,.125)");

                    legend.push({
                        label: "Andre",
                        value: other,
                        color: "rgba(0,0,0,.125)"
                    });
                }
            }

            _this.setState({
                loading: false,
                summary: {
                    total: chartTotal,
                    compare: compareTotal,
                    percent: comparePercent
                },
                legend: legend,
                chart: _extends({}, chart, {
                    data: data,
                    colors: colors
                })
            });
        }, _this.renderChart = function () {
            var chartTitle = _this.props.chartTitle;
            var chart = _this.state.chart;


            return React.createElement(Chart, _extends({}, chart, { type: "pie", enableSlicesLabels: false }));
        }, _this.renderLegendItem = function (item, index) {
            var label = item.label,
                value = item.value,
                color = item.color;


            var style = {
                backgroundColor: color
            };

            return React.createElement(
                "li",
                { key: index },
                React.createElement("div", { className: "admin-legend__chip", style: style }),
                React.createElement(
                    "b",
                    { className: "admin-legend__label" },
                    label
                ),
                React.createElement(
                    "i",
                    { className: "admin-legend__value" },
                    React.createElement(FormatMetric, { type: "INTEGER", value: value })
                )
            );
        }, _this.renderLegend = function () {
            var legend = _this.state.legend;


            if (!legend) {
                return false;
            }

            var size = "small";

            if (legend.length > 4) {
                size = "medium";
            }

            if (legend.length > 8) {
                size = "large";
            }

            return React.createElement(
                "section",
                { className: "admin-legend", "data-count": legend.length, "data-size": size },
                React.createElement(
                    "ul",
                    null,
                    legend.map(_this.renderLegendItem)
                )
            );
        }, _this.renderSummary = function () {
            var _this$props2 = _this.props,
                title = _this$props2.title,
                description = _this$props2.description,
                loadingTitle = _this$props2.loadingTitle;
            var _this$state = _this.state,
                summary = _this$state.summary,
                style = _this$state.style;


            var loading = _this.state.loading || _this.props.loading;

            if (loading || !summary) {

                return React.createElement(
                    "section",
                    { className: "summary" },
                    React.createElement(
                        "h1",
                        { className: "summary__title" },
                        loadingTitle
                    ),
                    React.createElement(WidgetSpinner, { style: style })
                );
            }

            var total = summary.total,
                compare = summary.compare,
                percent = summary.percent;


            if (percent > 0) {

                percent = parseFloat(percent).toFixed(1) + "%";
                description = description.replace("{percent}", percent);

                return React.createElement(
                    "section",
                    { className: "summary" },
                    React.createElement(
                        "h1",
                        { className: "summary__title" },
                        title
                    ),
                    React.createElement(
                        "h2",
                        { className: "summary__value" },
                        React.createElement(FormatMetric, { type: "INTEGER", value: total, decimals: "0" })
                    ),
                    React.createElement(
                        "p",
                        { className: "summary__description" },
                        description
                    )
                );
            }

            return React.createElement(
                "section",
                { className: "summary" },
                React.createElement(
                    "h1",
                    { className: "summary__title" },
                    title
                ),
                React.createElement(
                    "h2",
                    { className: "summary__value" },
                    React.createElement(FormatMetric, { type: "INTEGER", value: total, decimals: "0" })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsReportRegVsPub.prototype.componentDidMount = function componentDidMount() {
        this.getReport();
    };

    AnalyticsReportRegVsPub.prototype.render = function render() {
        var _state = this.state,
            style = _state.style,
            data = _state.data;


        return React.createElement(
            Widget,
            _extends({}, this.props, { style: style }),
            React.createElement(
                WidgetHeader,
                null,
                this.renderSummary(),
                this.renderChart()
            ),
            React.createElement(
                WidgetFooter,
                null,
                this.renderLegend()
            )
        );
    };

    return AnalyticsReportRegVsPub;
}(Component), _class.defaultProps = {
    widgetType: "analytics-owners-vs-total",
    widgetSize: "1:1",

    loadingTitle: "Trafikk denne uken",

    title: "Trafikk denne uken",
    description: "{percent} av hele DigitaltMuseum",
    colors: []

}, _temp2);
AnalyticsReportRegVsPub.propTypes = process.env.NODE_ENV !== "production" ? {
    title: PropTypes.string,
    listTitle: PropTypes.string,
    loadingTitle: PropTypes.string,

    report: PropTypes.object,
    compareReport: PropTypes.object
} : {};


export default AnalyticsReportRegVsPub;